import { render, staticRenderFns } from "./EditTextRightPicture.vue?vue&type=template&id=3b9d5ce2&"
import script from "./EditTextRightPicture.vue?vue&type=script&lang=js&"
export * from "./EditTextRightPicture.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports